import { combineReducers } from 'redux';

import { reducer as isOfficeIp } from './isOfficeIpModule';

export default combineReducers({
	isOfficeIp,
});
